import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, ArrowLeft } from 'lucide-react';

interface CampaignAdsGenerateSpinnerProps {
  showBackButton?: boolean;
  onBackClick?: () => void;
  backButtonText?: string;
}

export const CampaignAdsGenerateSpinner = ({ 
  showBackButton = false, 
  onBackClick,
  backButtonText = "Back to Campaigns"
}: CampaignAdsGenerateSpinnerProps) => {
  return (
    <div className="relative">
      {showBackButton && onBackClick && (
        <div className="absolute top-0 left-0 -mt-4">
          <Button 
            variant="outline" 
            size="sm" 
            onClick={onBackClick}
            className="flex items-center gap-2 text-gray-700 hover:text-gray-900"
          >
            <ArrowLeft className="h-4 w-4" />
            {backButtonText}
          </Button>
        </div>
      )}


    <Card className='p-6 flex flex-col gap-6 items-center h-full justify-center'>
      <CheckCircle className='w-16 h-16 text-green-500' />
      <div className='text-2xl text-gray-900 font-semibold text-center'>Campaigns are being created!</div>
      <CardContent className='p-6 rounded-lg bg-gray-50 border border-gray-100 flex flex-col gap-4 max-w-[500px] text-base text-gray-900'>
        <div className='text-center'>Your campaigns are being generated and will be ready for review shortly.</div>
        <div className='text-center'>You'll receive a notification when they're complete.</div>
      </CardContent>
    </Card>
    </div>
  );
};
